import styled from "styled-components";
import theme from "~/styles/theme";

export const StyledContentHolder = styled.div`
  background-color: ${theme.palette.neutral.primary.key};

  .div {
    background-color: ${theme.palette.brand.terciary.light};
    border-bottom-left-radius: 48px;
    border-bottom-right-radius: 48px;
  }
`;

export const ContentHolder = styled.div`
  text-align: left;
  margin: 80px 10px 0 10px;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    margin: 80px 0;
  }

  h1 {
    text-align: center;
    font-weight: 700;
  }

  p,
  strong,
  li {
    font-family: ${theme.typography.fontFamilyRegular};
    color: ${theme.palette.neutral.primary.key};
    font-size: 16px;
  }

  ul {
    list-style: disc;
    margin-left: 48px;

    li {
      margin-bottom: 8px;
    }

    ul {
      list-style: circle;
      margin-left: 48px;
    }
  }
`;
